import { render, staticRenderFns } from "./GamePlaceFilter.vue?vue&type=template&id=1b67be7b"
import script from "./GamePlaceFilter.vue?vue&type=script&lang=js"
export * from "./GamePlaceFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports